import { render, staticRenderFns } from "./afterSaleOrderDet.vue?vue&type=template&id=5da2ab64&scoped=true"
import script from "./afterSaleOrderDet.vue?vue&type=script&lang=js"
export * from "./afterSaleOrderDet.vue?vue&type=script&lang=js"
import style0 from "./afterSaleOrderDet.vue?vue&type=style&index=0&id=5da2ab64&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da2ab64",
  null
  
)

export default component.exports